import React, { Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EditCategoryForm from "../../Components/Forms/EditCategoryForm";
import styles from "../MainPages.module.css";
const EditCategory = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return null;

  return (
    <Fragment>
      <section className={`${styles["cd-cardSection-category"]} ${styles["cd-bgGlass"]}`}>
        <div className={styles["cd-cardHeader"]} >
          <div>
            <button
              type="button"
              className={styles["cd-backBtn-category"]}
              onClick={() => navigate(-1)}
            >
              ← Go Back
            </button>
          </div>
        </div>
      </section>
      <EditCategoryForm slug={slug} />;
    </Fragment>
  );



};

export default EditCategory;
